import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=72aa0130&scoped=true&"
import script from "./OffersList.vue?vue&type=script&lang=js&"
export * from "./OffersList.vue?vue&type=script&lang=js&"
import style0 from "./OffersList.vue?vue&type=style&index=0&id=72aa0130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa0130",
  null
  
)

export default component.exports